export const isImageMimeType = (mimeType: string): boolean =>
  mimeType.startsWith("image/");
